import { InventoryOverviewPage } from 'pages/inventory/overview';

export const InventoryOverviewView = () => {
  return <InventoryOverviewPage />;
};
